@let route = route$ | async;
@let counter = route ? route.viaLocationIds.length + 2 : 0;
<nz-collapse [nzBordered]="false" nzGhost>
  <nz-collapse-panel
    #userPanel
    [nzHeader]="
      route
        ? routeKnowledgeViaPointsSectionHeader
        : sharedRouteDataSectionHeader
    "
    [nzActive]="false"
    [nzShowArrow]="true"
  >
    @if (route) {
      <div class="via-points-list">
        <!-- Start location -->
        <div class="icon-wrapper">
          <fa-icon [icon]="faLocationDot"></fa-icon>
        </div>
        <div class="fw-normal ms-2">
          {{
            route.startLocationId | locationIdToLocation | async | locationName
          }}
        </div>
        <ng-template [ngTemplateOutlet]="spacerRow"></ng-template>

        <!-- Via locations -->
        @for (locationId of route.viaLocationIds; track locationId) {
          <div class="icon-wrapper">
            <fa-icon [icon]="faCircle"></fa-icon>
          </div>
          <div class="ms-2">
            {{ locationId | locationIdToLocation | async | locationName }}
          </div>
          <ng-template [ngTemplateOutlet]="spacerRow"></ng-template>
        }

        <!-- End location -->
        <div class="icon-wrapper">
          <fa-icon [icon]="faFlag"></fa-icon>
        </div>
        <div class="fw-normal ms-2">
          {{
            route.endLocationId | locationIdToLocation | async | locationName
          }}
        </div>
      </div>
    } @else if (sharedRouteData) {
      <div class="via-points-list">
        <!-- Start location -->
        <div class="icon-wrapper">
          <fa-icon [icon]="faLocationDot"></fa-icon>
        </div>
        <div class="fw-normal ms-2">
          {{ sharedRouteData.startLocation | locationName }}
        </div>
        <ng-template [ngTemplateOutlet]="spacerRow"></ng-template>

        <!-- Via locations -->
        @for (viaLocation of sharedRouteData.viaLocations; track viaLocation) {
          <div class="icon-wrapper">
            <fa-icon [icon]="faCircle"></fa-icon>
          </div>
          <div class="ms-2">
            {{ viaLocation | locationName }}
          </div>
          <ng-template [ngTemplateOutlet]="spacerRow"></ng-template>
        }

        <!-- End location -->
        <div class="icon-wrapper">
          <fa-icon [icon]="faFlag"></fa-icon>
        </div>
        <div class="fw-normal ms-2">
          {{ sharedRouteData.endLocation | locationName }}
        </div>
      </div>
    }
  </nz-collapse-panel>

  <ng-template #routeKnowledgeViaPointsSectionHeader>
    <div class="d-flex justify-content-between">
      <span class="fw-bold">
        {{ 'general.route_knowledge' | translate }} ({{ counter }})
      </span>
    </div>
  </ng-template>

  <ng-template #sharedRouteDataSectionHeader>
    <div class="d-flex justify-content-between">
      <span class="fw-bold">
        {{ 'general.route_knowledge' | translate }} ({{
          sharedRouteData && sharedRouteData.viaLocations
            ? sharedRouteData.viaLocations.length + 2
            : 0
        }})
      </span>
    </div>
  </ng-template>
</nz-collapse>

<ng-template #spacerRow>
  <div class="vertical-spacer"></div>
  <div class="empty-space">&nbsp;</div>
</ng-template>
